export default __webpack_public_path__ + "static/media/diamond-clarity-4@2x.2ceabffc.png";